/**
 * 农历1900-2100的润大小信息表
 * 数据来源：jjonline/calendar.js（香港天文台数据）
 * 每元素编码：bit0-3=闰月(0无闰月), bit4-15=12个月大小(1=30天), bit16=闰月大小
 */
const LUNAR_INFO = [
  0x04bd8, 0x04ae0, 0x0a570, 0x054d5, 0x0d260, 0x0d950, 0x16554, 0x056a0, 0x09ad0, 0x055d2,
  0x04ae0, 0x0a5b6, 0x0a4d0, 0x0d250, 0x1d255, 0x0b540, 0x0d6a0, 0x0ada2, 0x095b0, 0x14977,
  0x04970, 0x0a4b0, 0x0b4b5, 0x06a50, 0x06d40, 0x1ab54, 0x02b60, 0x09570, 0x052f2, 0x04970,
  0x06566, 0x0d4a0, 0x0ea50, 0x06e95, 0x05ad0, 0x02b60, 0x186e3, 0x092e0, 0x1c8d7, 0x0c950,
  0x0d4a0, 0x1d8a6, 0x0b550, 0x056a0, 0x1a5b4, 0x025d0, 0x092d0, 0x0d2b2, 0x0a950, 0x0b557,
  0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5b0, 0x14573, 0x052b0, 0x0a9a8, 0x0e950, 0x06aa0,
  0x0aea6, 0x0ab50, 0x04b60, 0x0aae4, 0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57, 0x056a0,
  0x096d0, 0x04dd5, 0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b6a0, 0x195a6,
  0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46, 0x0ab60, 0x09570,
  0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58, 0x055c0, 0x0ab60, 0x096d5, 0x092e0,
  0x0c960, 0x0d954, 0x0d4a0, 0x0da50, 0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0, 0x0cab5,
  0x0a950, 0x0b4a0, 0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0, 0x0a930,
  0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260, 0x0ea65, 0x0d530,
  0x05aa0, 0x076a3, 0x096d0, 0x04afb, 0x04ad0, 0x0a4d0, 0x1d0b6, 0x0d250, 0x0d520, 0x0dd45,
  0x0b5a0, 0x056d0, 0x055b2, 0x049b0, 0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20, 0x0ada0,
  0x14b63, 0x09370, 0x049f8, 0x04970, 0x064b0, 0x168a6, 0x0ea50, 0x06b20, 0x1a6c4, 0x0aae0,
  0x0a2e0, 0x0d2e3, 0x0c960, 0x0d557, 0x0d4a0, 0x0da50, 0x05d55, 0x056a0, 0x0a6d0, 0x055d4,
  0x052d0, 0x0a9b8, 0x0a950, 0x0b4a0, 0x0b6a6, 0x0ad50, 0x055a0, 0x0aba4, 0x0a5b0, 0x052b0,
  0x0b273, 0x06930, 0x07337, 0x06aa0, 0x0ad50, 0x14b55, 0x04b60, 0x0a570, 0x054e4, 0x0d160,
  0x0e968, 0x0d520, 0x0daa0, 0x16aa6, 0x056d0, 0x04ae0, 0x0a9d4, 0x0a2d0, 0x0d150, 0x0f252,
  0x0d520,
];

const TIANGAN = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'];
const DIZHI = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];
const SHENGXIAO = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'];

export { TIANGAN, DIZHI, SHENGXIAO };

export interface LunarDate {
  year: number;
  month: number;
  day: number;
  isLeap: boolean;
}

export interface BaziPillar {
  year: string;
  month: string;
  day: string;
  hour: string;
}

export interface BaziDetail {
  pillars: BaziPillar;
  lunarDate: LunarDate;
  solarDate: { year: number; month: number; day: number };
  zodiac: string;
}

function lYearDays(y: number): number {
  let sum = 348;
  for (let i = 0x8000; i > 0x8; i >>= 1) {
    sum += (LUNAR_INFO[y - 1900] & i) ? 1 : 0;
  }
  return sum + leapDays(y);
}

function leapDays(y: number): number {
  if (leapMonth(y)) {
    return (LUNAR_INFO[y - 1900] & 0x10000) ? 30 : 29;
  }
  return 0;
}

function leapMonth(y: number): number {
  return LUNAR_INFO[y - 1900] & 0xf;
}

function monthDays(y: number, m: number): number {
  return (LUNAR_INFO[y - 1900] & (0x10000 >> m)) ? 30 : 29;
}

/**
 * 公历转农历
 */
export function solarToLunar(sy: number, sm: number, sd: number): LunarDate | null {
  if (sy < 1900 || sy > 2100) return null;
  if (sy === 1900 && sm === 1 && sd < 31) return null;

  // 使用 UTC 计算，避免本地时区 / 中国夏令时（1986-1991）导致整体偏移一天
  const baseDate = new Date(Date.UTC(1900, 0, 31));
  const objDate = new Date(Date.UTC(sy, sm - 1, sd));
  let offset = Math.floor((objDate.getTime() - baseDate.getTime()) / 86400000);

  let year = 1900;
  let temp = 0;

  for (year = 1900; year < 2101 && offset > 0; year++) {
    temp = lYearDays(year);
    offset -= temp;
  }

  if (offset < 0) {
    offset += temp;
    year--;
  }

  const leap = leapMonth(year);
  let isLeap = false;
  let month = 1;

  for (month = 1; month < 13 && offset > 0; month++) {
    if (leap > 0 && month === leap + 1 && !isLeap) {
      month--;
      isLeap = true;
      temp = leapDays(year);
    } else {
      temp = monthDays(year, month);
    }

    if (isLeap && month === leap + 1) {
      isLeap = false;
    }
    offset -= temp;
  }

  if (offset === 0 && leap > 0 && month === leap + 1) {
    if (isLeap) {
      isLeap = false;
    } else {
      isLeap = true;
      month--;
    }
  }

  if (offset < 0) {
    offset += temp;
    month--;
  }

  return { year, month, day: offset + 1, isLeap };
}

/**
 * 农历转公历
 */
export function lunarToSolar(lYear: number, lMonth: number, lDay: number, isLeapMonth: boolean): { year: number; month: number; day: number } | null {
  const leap = leapMonth(lYear);
  if (isLeapMonth && leap !== lMonth) return null;
  if (lYear < 1900 || lYear > 2100) return null;

  const day = monthDays(lYear, lMonth);
  let maxDay = day;
  if (isLeapMonth) {
    maxDay = leapDays(lYear);
  }
  if (lDay > maxDay) return null;

  let offset = 0;
  for (let i = 1900; i < lYear; i++) {
    offset += lYearDays(i);
  }

  let isAdd = false;
  for (let i = 1; i < lMonth; i++) {
    const lm = leapMonth(lYear);
    if (!isAdd && lm <= i && lm > 0) {
      offset += leapDays(lYear);
      isAdd = true;
    }
    offset += monthDays(lYear, i);
  }

  if (isLeapMonth) {
    offset += day;
  }

  // 1900年农历正月初一 = 1900年1月31日（使用 UTC，避免本地时区 / 夏令时导致整体偏移一天）
  const baseDate = new Date(Date.UTC(1900, 0, 31));
  const targetDate = new Date(baseDate.getTime() + (offset + lDay - 1) * 86400000);

  return {
    year: targetDate.getUTCFullYear(),
    month: targetDate.getUTCMonth() + 1,
    day: targetDate.getUTCDate(),
  };
}

/**
 * 获取某年是否有闰月，闰哪个月
 */
export function getLeapMonth(year: number): number {
  if (year < 1900 || year > 2100) return 0;
  return leapMonth(year);
}

/**
 * 获取农历某月的天数
 */
export function getLunarMonthDays(year: number, month: number, isLeap: boolean): number {
  if (year < 1900 || year > 2100) return 0;
  if (isLeap) {
    const leap = leapMonth(year);
    if (leap !== month) return 0;
    return leapDays(year);
  }
  return monthDays(year, month);
}

/**
 * 计算日柱（基于公历日期，使用干支纪日算法）
 * 以 2000-01-01（戊午日，干支序号 54）为基准。
 * 注意：必须用 Date.UTC 计算天数差，避免手机本地时区（如 UTC+8）
 * 导致 Math.floor(getTime()/86400000) 丢掉时区小数，使日柱“早算一天”。
 */
function getDayPillar(solarYear: number, solarMonth: number, solarDay: number): string {
  const diffDays = Math.floor(
    (Date.UTC(solarYear, solarMonth - 1, solarDay) - Date.UTC(2000, 0, 1)) / 86400000
  );
  const combined = ((54 + diffDays) % 60 + 60) % 60;
  const stemIndex = combined % 10;
  const branchIndex = combined % 12;
  return TIANGAN[stemIndex] + DIZHI[branchIndex];
}

/**
 * 计算时柱
 * 规则：日干定子时天干，甲己日甲子时，乙庚日丙子时...
 */
function getHourPillar(dayStemIndex: number, hourBranchIndex: number): string {
  const startStem = (dayStemIndex % 5) * 2;
  const stemIndex = (startStem + hourBranchIndex) % 10;
  return TIANGAN[stemIndex] + DIZHI[hourBranchIndex];
}

/**
 * 计算月柱（简化版：基于农历月份）
 * 注：严格八字应以节气为界，此处采用农历月近似算法，适用于绝大多数情况
 */
function getMonthPillar(lunarYear: number, lunarMonth: number): string {
  const yearStemIndex = ((lunarYear - 4) % 10 + 10) % 10;
  // 月支：正月=寅(2), 二月=卯(3)...
  const branchIndex = ((lunarMonth + 1) % 12 + 12) % 12;
  // 月干：甲己之年丙作首 => (年干*2 + 2 + (月-1)) % 10
  const stemIndex = ((yearStemIndex * 2 + 2 + (lunarMonth - 1)) % 10 + 10) % 10;
  return TIANGAN[stemIndex] + DIZHI[branchIndex];
}

/**
 * 计算年柱
 */
function getYearPillar(lunarYear: number): string {
  const stemIndex = ((lunarYear - 4) % 10 + 10) % 10;
  const branchIndex = ((lunarYear - 4) % 12 + 12) % 12;
  return TIANGAN[stemIndex] + DIZHI[branchIndex];
}

/**
 * 从公历日期计算八字
 */
export function getBaziFromSolar(solarYear: number, solarMonth: number, solarDay: number, hourBranchIndex: number): BaziDetail | null {
  const lunar = solarToLunar(solarYear, solarMonth, solarDay);
  if (!lunar) return null;

  const yearPillar = getYearPillar(lunar.year);
  const monthPillar = getMonthPillar(lunar.year, lunar.month);
  const dayPillar = getDayPillar(solarYear, solarMonth, solarDay);
  const dayStemIndex = TIANGAN.indexOf(dayPillar[0]);
  const hourPillar = getHourPillar(dayStemIndex, hourBranchIndex);

  const branchIndex = ((lunar.year - 4) % 12 + 12) % 12;

  return {
    pillars: {
      year: yearPillar,
      month: monthPillar,
      day: dayPillar,
      hour: hourPillar,
    },
    lunarDate: lunar,
    solarDate: { year: solarYear, month: solarMonth, day: solarDay },
    zodiac: SHENGXIAO[branchIndex],
  };
}

/**
 * 从农历日期计算八字
 */
export function getBaziFromLunar(lYear: number, lMonth: number, lDay: number, isLeap: boolean, hourBranchIndex: number): BaziDetail | null {
  const solar = lunarToSolar(lYear, lMonth, lDay, isLeap);
  if (!solar) return null;
  return getBaziFromSolar(solar.year, solar.month, solar.day, hourBranchIndex);
}

/**
 * 格式化农历日期显示
 */
export function formatLunarDate(lunar: LunarDate): string {
  const monthNames = ['正', '二', '三', '四', '五', '六', '七', '八', '九', '十', '冬', '腊'];
  const dayPrefixes = ['初', '十', '廿', '卅'];
  const dayNums = ['日', '一', '二', '三', '四', '五', '六', '七', '八', '九'];

  const monthStr = (lunar.isLeap ? '闰' : '') + monthNames[lunar.month - 1] + '月';

  let dayStr: string;
  const d = lunar.day;
  if (d === 10) {
    dayStr = '初十';
  } else if (d === 20) {
    dayStr = '二十';
  } else if (d === 30) {
    dayStr = '三十';
  } else {
    const prefix = dayPrefixes[Math.floor(d / 10)];
    const num = dayNums[d % 10];
    dayStr = prefix + num;
  }

  return `${lunar.year}年${monthStr}${dayStr}`;
}